var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 63,
    viewBox: "0 0 80 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.6045 21.8817C79.6045 7.93512 70.7061 -7.77923e-07 60.8457 -1.63995e-06C51.9473 -2.41787e-06 44.4919 7.4542 44.4919 16.5916C44.4919 25.4885 50.7448 31.7405 58.9217 31.7405C60.3647 31.7405 62.2887 31.2595 63.0102 31.0191C61.3267 39.1947 53.3903 49.0534 45.6944 53.6221L56.9977 63C70.2251 53.6221 79.6045 38.4733 79.6045 21.8817ZM35.1125 21.8817C35.1125 7.93512 26.2141 -4.66754e-06 16.3537 -5.52956e-06C7.45526 -6.30749e-06 -0.000155361 7.4542 -0.00015616 16.5916C-0.000156938 25.4885 6.25277 31.7405 14.4297 31.7405C15.8727 31.7405 17.7967 31.2595 18.5181 31.0191C16.8347 39.1947 8.89825 49.0534 1.20232 53.6221L12.5057 63C25.7331 53.6221 35.1125 38.4733 35.1125 21.8817Z",
    fill: "#302F68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteEnd);
export default __webpack_public_path__ + "static/media/quote-end.40b6e30f3045182364aaa8b136877d85.svg";
export { ForwardRef as ReactComponent };